export const FETCH_PATIENT_ROIS = 'src/PatientRois/FETCH_PATIENT_ROIS';
export const FETCH_PATIENT_ROIS_SUCCESS =
	'src/PatientRois/FETCH_PATIENT_ROIS_SUCCESS';
export const FETCH_PATIENT_ROIS_ERROR =
	'src/PatientRois/FETCH_PATIENT_ROIS_ERROR';

export const REVOKE_PATIENT_ROI = 'src/PatientRois/REVOKE_PATIENT_ROI';
export const REVOKE_PATIENT_ROI_SUCCESS =
	'src/PatientRois/REVOKE_PATIENT_ROI_SUCCESS';
export const REVOKE_PATIENT_ROI_ERROR =
	'src/PatientRois/REVOKE_PATIENT_ROI_ERROR';

export const RENEW_PATIENT_ROI = 'src/PatientRois/RENEW_PATIENT_ROI';
export const RENEW_PATIENT_ROI_SUCCESS =
	'src/PatientRois/RENEW_PATIENT_ROI_SUCCESS';
export const RENEW_PATIENT_ROI_ERROR =
	'src/PatientRois/RENEW_PATIENT_ROI_ERROR';
